import BuildProgressBanner from '@/components/build/build-progress-banner';
import { getActiveBuild } from '@/entities/build.entity';
import { $lastBuildComplete } from '@/entities/build-live.entity';
import { $profile } from '@/entities/profile-entity';
import { PageScroll } from '@/layouts/page-layout';
import { useBuildSubscription } from '@/hooks/use-build-subscription';
import { useUnit } from 'effector-react';
import MyBuildsSection from '../builder/my-builds-section';
import { useMyBuilds } from '../builder/use-my-builds';

export default function ApkBuildsPage() {
	const profile = useUnit($profile);
	const isAdmin = profile?.role === 'admin';
	const { builds, loading, loadBuilds } = useMyBuilds();
	const activeBuild = getActiveBuild(builds);
	const { progress: liveProgress, logs } = useBuildSubscription(activeBuild?.id);
	const lastBuildComplete = useUnit($lastBuildComplete);
	const recentFailedBuild =
		lastBuildComplete && !lastBuildComplete.success
			? builds.find(build => build.id === lastBuildComplete.buildId)
			: null;

	async function handleBuildCancelled() {
		await loadBuilds();
	}

	async function handleBuildInstalled() {
		await loadBuilds();
	}

	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-3'>
			{activeBuild ? (
				<BuildProgressBanner
					build={activeBuild}
					liveProgress={liveProgress}
					logs={logs}
					showAdminLogs={isAdmin}
					onCancel={handleBuildCancelled}
				/>
			) : null}

			{!activeBuild && recentFailedBuild ? (
				<BuildProgressBanner
					build={recentFailedBuild}
					showAdminLogs={isAdmin}
					onCancel={handleBuildCancelled}
				/>
			) : null}

			<MyBuildsSection builds={builds} loading={loading} onCancel={handleBuildCancelled} onInstalled={handleBuildInstalled} />
		</PageScroll>
	);
}
